import React, { useContext, useEffect, useRef, useState } from "react";
import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import Dashboard_LineChart from "./Dashboard_LineChart/Dashboard_LineChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faCalendarCheck,
  faCartFlatbed,
  faChartSimple,
  faCircleUser,
  faComments,
  faExclamationCircle,
  faGlobe,
  faIndustry,
  faLightbulb,
  faMessage,
  faPhone,
  faRepeat,
  faTape,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import Rating from "@material-ui/lab/Rating";
import { Context } from "../../../utils/context";
import { faJediOrder } from "@fortawesome/free-brands-svg-icons";
import { IDS, RoleId } from "../../../utils/common";

function AdvanceDashboard() {
  const [value, setValue] = useState(2);
  const navigate = useNavigate();
  const { getData, usertype, isAllow } = useContext(Context);

  const [result, setResult] = useState({});
  const [pieData, setPieData] = useState();
  const [avgRating, setAvgRating] = useState(null);
  const [statusCounts, setStatusCounts] = useState({});
  const [chartData, setChartData] = useState({});

  const getDataAll = async () => {
    const result = await getData("/admin/dashboard/dashboard-data");
    setStatusCounts(result?.data);
  };
  const getChartData = async () => {
    const result = await getData("/admin/dashboard/sales-chart");
    setChartData(result.data);
  };

  useEffect(() => {
    getDataAll();
    getChartData();
  }, []);

  const [user, setUser] = useState({});

  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      await setUser(response?.data);
    }
  };

  useEffect(() => {
    GetUser();
  }, []);

  return (
    <div>
      <div className="main-advancedashboard">
        <section className="AdvanceDashboard">
          <div className="AdvanceDashboardTabs">
            <Header title={"Dashboard"} link={"/masters/social_links"} />
            <div className=""></div>
          </div>
        </section>

        {user.role_id === RoleId.Admin && (
          <div className="Main-Section-Advanced-Dashboard">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  {/* Designs Card */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/designs")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Designs</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                className="icon"
                                icon={faChartSimple}
                              />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Designs</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">
                              {statusCounts?.total_designs}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer Feedback Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/design/ratings/:id")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Customer Feedback</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faUser} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Messages</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">
                              {statusCounts?.total_reviews || 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Today's Payment Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div className="bucket-card-holder">
                      <div className="second_card_holder">
                        <h6 className="title">Total</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                className="icon"
                                icon={faWallet}
                              />
                            </div>
                            <div className="text_holder">
                              <p className="text">Today's Payment</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">
                              {statusCounts?.todays_total || "0.00"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Total Customer Card - Unified Design */}
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                    <div
                      className="bucket-card-holder"
                      onClick={() => navigate("/customers")}
                    >
                      <div className="second_card_holder">
                        <h6 className="title">Total Customer</h6>
                        <div className="inner_div">
                          <div className="top_heading">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="icon" icon={faUser} />
                            </div>
                            <div className="text_holder">
                              <p className="text">Total Customer</p>
                            </div>
                          </div>
                          <div className="count_holder">
                            <p className="count">
                              {statusCounts?.TotalCustomer || 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-12 mb-3">
                    <div className="bucket-card-holder">
                      <div className="card-heading-holder">
                        <h6>Sales</h6>
                      </div>
                      <div className="card-number-holder">
                        <h3>{chartData?.total}</h3>
                        <p>This month</p>
                      </div>
                      <div className="card-chart-holder">
                        <Dashboard_LineChart chartData={chartData?.data} />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-12 mb-3">
                    {isAllow.includes(IDS.Order.List) ? (
                      <div
                        className="bucket-card-holder"
                        onClick={() => navigate("/orders/all-orders")}
                      >
                        <div className="card-heading-holder">
                          <h6>Today's Orders</h6>
                        </div>
                        <div className="card-number-holder">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="inner_icon"
                              icon={faCartFlatbed}
                            />
                          </div>
                          <div className="text_holder">
                            <h3 className="count_text">
                              {statusCounts?.total_Orders}
                            </h3>
                            <h3 className="title_text">Today Count</h3>
                          </div>
                        </div>
                        <div className="card-table-holder">
                          <Table className="mb-0">
                            <tbody>
                              <tr>
                                <td>Pending Orders</td>
                                <td className="num">
                                  {statusCounts?.Pending_orders}
                                </td>
                              </tr>

                              <tr>
                                <td>Confirm Orders</td>
                                <td className="num">
                                  {statusCounts?.Confirm_orders}
                                </td>
                              </tr>

                              <tr>
                                <td>Processing Orders</td>
                                <td className="num">
                                  {statusCounts?.Processing_orders}
                                </td>
                              </tr>

                              <tr>
                                <td>Assign Expert To Material Pickup Orders</td>
                                <td className="num">
                                  {statusCounts?.AssignExpertToMaterialPickup}
                                </td>
                              </tr>

                              <tr>
                                <td>Pickup Material Orders</td>
                                <td className="num">
                                  {statusCounts?.PickupMaterial}
                                </td>
                              </tr>

                              <tr>
                                <td>Material Delivered To Vendor Orders</td>
                                <td className="num">
                                  {statusCounts?.MaterialDeliverdToVendor}
                                </td>
                              </tr>

                              <tr>
                                <td>Ready To Delivered Orders</td>
                                <td className="num">
                                  {statusCounts?.ReadyToDelivered}
                                </td>
                              </tr>

                              <tr>
                                <td>Vendor Material Pickup Orders</td>
                                <td className="num">
                                  {statusCounts?.VendorMaterialPickup}
                                </td>
                              </tr>

                              <tr>
                                <td>Assign Expert To Deliver Orders</td>
                                <td className="num">
                                  {statusCounts?.AssignExpertToDeliver}
                                </td>
                              </tr>

                              <tr>
                                <td>Delivered Orders</td>
                                <td className="num">
                                  {statusCounts?.Delivered_orders}
                                </td>
                              </tr>

                              <tr>
                                <td>Cancelled Orders</td>
                                <td className="num">
                                  {statusCounts?.Cancelled_orders}
                                </td>
                              </tr>

                              <tr>
                                <td>Restitching Pending Orders</td>
                                <td className="num">
                                  {statusCounts?.RestichingPending}
                                </td>
                              </tr>

                              <tr>
                                <td>Restitching Orders</td>
                                <td className="num">
                                  {statusCounts?.RestichingOrders}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdvanceDashboard;
